<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<a id="title12">
<p class="p"><span>Thanks to Dan Cuoco and the IBRO members for their help and contributions.</span></p>
<p class="p"><span><br/> To all the memorable boxers (and their families) that are not in this book, the authors regret that due to a lack of photos not all top Chicago fighters could be included. Thank you for all the thrills you have provided Chicago fans over the years.</span></p></a></div><a id="title12">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439614785_ack01.vue?48319547